import type { ThreadTempQuotaError } from './threadTempApi';

/**
 * 一時ファイルの容量超過を、アップロード箇所（mutations 経由）から画面のモーダルへ伝える。
 * アップロード関数は同じエラーを throw し続けるので、モーダルが無い画面でも従来どおり失敗として扱われる。
 */
const EVENT_NAME = 'notreu:thread-temp-quota-exceeded';

export const emitThreadTempQuotaExceeded = (err: ThreadTempQuotaError): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<ThreadTempQuotaError>(EVENT_NAME, { detail: err }));
};

export const subscribeThreadTempQuotaExceeded = (
  handler: (err: ThreadTempQuotaError) => void
): (() => void) => {
  if (typeof window === 'undefined') return () => {};
  const listener = (e: Event) => handler((e as CustomEvent<ThreadTempQuotaError>).detail);
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
};
